import { render, staticRenderFns } from "./Sizetext.vue?vue&type=template&id=b5ae97f0&scoped=true"
import script from "./Sizetext.vue?vue&type=script&lang=js"
export * from "./Sizetext.vue?vue&type=script&lang=js"
import style0 from "./Sizetext.vue?vue&type=style&index=0&id=b5ae97f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ae97f0",
  null
  
)

export default component.exports